import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { useAuth } from "react-oidc-context";
import { cognitoLogoutUrl } from "../auth/authConfig";
import { markSignedOut } from "../auth/signedOut";
import { getEnv } from "../hooks/useEnv";

export default function Forbidden() {
  const auth = useAuth();
  return (
    <Box p={8}>
      <Heading size="lg">Access denied</Heading>
      <Text mt={2} color="gray.600">
        Your account isn&apos;t a member of the <code>Support</code> Workspace
        group, which is required to use this app. If you think this is wrong,
        contact a Workspace admin.
      </Text>
      <Button
        mt={6}
        onClick={async () => {
          markSignedOut();
          await auth.removeUser();
          window.location.href = cognitoLogoutUrl(getEnv());
        }}
      >
        Sign out
      </Button>
    </Box>
  );
}
